import type {
  PriceChangeRounding,
  PriceChangeUnit,
  PriceTransform,
} from "@intelligems/ig-types/dtos/variations";

import { ensureNumber } from "../common";

export function getPriceTransformFromVariation(variation?: {
  priceChange?: string | null;
  priceChangeUnit?: PriceChangeUnit | null;
  priceRoundingType?: PriceChangeRounding | null;
  priceRoundingAmount?: string | null;
}) {
  if (variation === undefined || !variation.priceChange) {
    return undefined;
  }

  let change = ensureNumber(variation.priceChange);
  if (isNaN(change)) {
    change = 0;
  }
  const transform: PriceTransform = {
    change,
    changeUnit: variation.priceChangeUnit ?? "percent",
    roundingType: variation.priceRoundingType ?? undefined,
    roundingAmount: ensureNumber(variation.priceRoundingAmount) ?? undefined,
  };
  return transform;
}
